export const mapValues = (obj, getReturnValue) => {
  const returnObject = {};
  Object.keys(obj)?.forEach(key => (returnObject[key] = getReturnValue(obj[key])));
  return returnObject;
};

export const isEmpty = obj => !obj || Object.keys(obj)?.length < 1;
